var image_upload_default = {
  "container": "p-6-Z",
  "disabled": "snP8-",
  "imageInput": "tw5R0",
  "overlay": "_-4iGv",
  "text": "aVyN4",
  "shown": "g-njm",
  "hide": "_08bRT",
  "spinner": "n9Swl",
  "spin": "h2InQ"
};
export {
  image_upload_default as default
};
//# sourceMappingURL=image-upload-scss.js.map
